"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.5 20.7",
    width: "24.5",
    height: "20.7"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M9.7,5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24,20.7H0.5c-0.2,0-0.3-0.1-0.4-0.3C0,20.3,0,20.1,0.1,20l2.6-4.3l0.9,0.5l-2.1,3.6h21.7l-1.5-2.3l0.8-0.5l2,3.1 c0.1,0.2,0.1,0.3,0,0.5C24.4,20.6,24.2,20.7,24,20.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M21.4,16.3"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.5,5.3l-2.2-3.8l-2.2,3.8L9.2,4.8l2.6-4.5c0.2-0.3,0.7-0.3,0.9,0l2.6,4.6L14.5,5.3z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#F8B133",
    d: "M15.2,9.3c-0.1,0.1,0,0.3,0,0.3v9.2H9.9V9.7c0,0,0-0.2-0.1-0.3C9.7,9.2,9.4,9.3,9.4,9.3H4v-3h17.1v3h-5.5 C15.6,9.3,15.3,9.2,15.2,9.3"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    fill: "#F8B133",
    points: "8.5,15.9 8.5,18.9 4,18.9 4,9.9 8.5,9.9 8.5,12.9 9.5,12.9 9.5,15.9       "
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#F8B133",
    d: "M15.5,12.8h0.3c0,0,0.4,0,0.6-0.2c0.3-0.3,0.2-0.8,0.2-0.8v-2H21c0,0,0.2,2.5-0.8,3.5 c-1,1-3.6,0.8-3.6,0.8v0.5c0,0,2.6-0.3,3.6,0.8c1,1,0.8,3.5,0.8,3.5h-4.3v-2c0,0,0-0.6-0.2-0.8c-0.3-0.3-0.6-0.2-0.6-0.2h-0.3 V12.8z"
  }));
};

exports["default"] = _default;